<div class="row col-md-12">
  <div class="col-md-9 dashboard-main">
    <!--Quick Price lookup-->
    <div class="dashboard-section">
      <app-dashboard-quickprice></app-dashboard-quickprice>
    </div>
    <!--Order Status-->
    <div class="dashboard-section">
      <app-dashboard-orderstatus></app-dashboard-orderstatus>
    </div>
    <!--RMA-->
    <div class="dashboard-section">
      <app-dashboard-rma></app-dashboard-rma>
    </div>
  </div>
  <div class="col-md-3 clear-padding ">
    <!--Quick links-->
    <div style="background-color: #003359; padding-left: 20px; padding-right: 20px; width: 100%; text-align: center;">
      <div class="row-no-margin quick-links">
        <div class="quick-link-tile" style="padding-top:10px;">
          <!--YMH-->
          <!--<a class="clickable" target="_blank" href="https://www.tolomatic.com/info-center/tools/your-motor-here/"><fa-icon [icon]="faGlobe" class="clickable yellow-color"></fa-icon></a>-->
          <fa-icon [icon]="faGlobe" (click)="openWindow('https://www.tolomatic.com');" class="fa-thin clickable yellow-color fa-3x "></fa-icon>
          <br />
          <a class="clickable quick-links-text" target="_blank" href="https://www.tolomatic.com"><span>Tolomatic.com</span></a>
        </div>
        <div class="quick-link-tile">
          <!--Sizing-->
          <a class="clickable " target="_blank" href="https://sizeit.tolomatic.com"><img style="width:80px;" src="./assets/images/sizing-icon-150-150x150.png" /></a>
          <br />
          <a class="clickable quick-links-text" target="_blank" href="https://sizeit.tolomatic.com"><span>Actuator Sizing</span></a>
        </div>
      </div>

      <div class="row-no-margin quick-links">
        <div class="quick-link-tile">
          <!--Cad Library-->
          <a class="clickable" target="_blank" href="https://www.tolomatic.com/info-center/cad-library/"><img style="width:80px;" src="./assets/images/cad-icon-150-150x150.png" /></a>
          <br />
          <a class="clickable quick-links-text" target="_blank" href="https://www.tolomatic.com/info-center/cad-library/"><span>CAD Library</span></a>
        </div>
        <div class="quick-link-tile">
          <!--YMH-->
          <a class="clickable" target="_blank" href="https://www.tolomatic.com/info-center/tools/your-motor-here/"><img style="width:80px;" src="./assets/images/YMH-icon-150-1-150x150.png" /></a>
          <br />
          <a class="clickable quick-links-text" target="_blank" href="https://www.tolomatic.com/info-center/tools/your-motor-here/"><span>YMH</span></a>
        </div>
      </div>
    </div>
    <div class="newsSection" style="min-height:200px;">
      <div class="row-no-margin" [hidden]="!ShowNewsUpdates">
        <div class="col-md-12 clear-padding">
          <span class="section-header-sm">NEWS &amp; UPDATES</span>
        </div>
        <div class="newslistitem" *ngFor="let item of NewsItemList">
          <app-news-item [NewsItem]="item" [CurUser]="CurUser">

          </app-news-item>
        </div>

      </div>
      <div class="row-no-margin" style="display:none;">
        <button class="blue" (click)="ViewAllNews()">VIEW ALL</button>
      </div>
      <div class="row-no-margin" >
        <!--Resources-->
        <span class="section-header-sm">RESOURCES</span>
        <div class="col-md-12 clear-padding" style="border-top: 1px solid #e2e1dd;">
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/support/application-worksheets/">Application Worksheet</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/products/electric-linear-actuators/">Electric Products</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/products/pneumatic-linear-actuators/">Pneumatic Products</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/products/power-transmission/">Power Transmission</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/info-center/">Tolomatic.com Info Center</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/support/">Product Support Page</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/info-center/product-support/#parts-maintenance">Parts and Maintenance Sheets</a>
          </div>
          <div class="newslistitem">
            <a target="_blank" href="https://www.tolomatic.com/storyslab?resid=1867">Pneumatic Products Repair Kits</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
